import { css, Global } from '@emotion/react';

import {
  getCssVariables,
  getFontFaces,
} from '../../../apps/explore/styles/CSSVariables';

export const WidgetStyles = () => (
  <Global
    styles={() => css`
      :root {
        ${getFontFaces()}

        * {
          box-sizing: border-box;
        }

        sembo-footer {
          ${getCssVariables()}

          a:hover {
            color: var(--color-black);
            text-decoration: none;
          }
        }
      }
    `}
  />
);
